/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import DataTable from 'react-data-table-component';
import Loader from '/client/src/components/Loader';

type PropsType = {
  eventId: number | string
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

let mock = {
  columns: []
};

const EventPageDetailVIPCodesURLs = ({ eventId }: PropsType): React.Element<'div'> => {
  const [vipcodesUrl, setVipcodesUrl] = React.useState([]);

  try {
    mock = require('./tableHeaders/urls.js');
  } catch (e) {
    console.warn('File "./tableHeaders/index.js" doesn\'t exist');
  }

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          setVipcodesUrl(_.get(response, 'data.result', []));
        } catch (e) {
          console.error('cant get VIP codes list');
        }
      }
    },
    []
  );

  return (
    <Loader
      url={`/api/v1/1/vipcodes/${eventId}/urls`}
      onLoaded={handleLoaded}
    >
      {!!_.size(vipcodesUrl) ?
        <DataTable
          columns={mock.columns()}
          data={vipcodesUrl}
          customStyles={customStyles}
          // Clicked
          pagination={_.size(vipcodesUrl) > 10}
          highlightOnHover
          responsive
          striped
          fixedHeader
          noHeader
          sortIcon={(): React.Element<typeof React.Fragment> => {
            return (
              <>
                <span className="-sort-desc" />
                <span className="-sort-asc" />
              </>
            );
          }}
        /> : <div className='panel-body'>
          VIP code Urls not found
        </div>  }
    </Loader>
  );
};

export default EventPageDetailVIPCodesURLs;
